import React from 'react';
import PropTypes from 'prop-types';
import CardActionsPanel from './CardActionsPanel';

const CardActions = ({
  children,
}) => (
  <div className="Card__Actions">
    {children}
  </div>
);

CardActions.Panel = CardActionsPanel;

CardActions.propTypes = {
  children: PropTypes.any.isRequired,
};

export default CardActions;
